var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AI insight symbol"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 7H16.75C18.857 7 19.91 7 20.667 7.506C20.9943 7.72474 21.2753 8.00575 21.494 8.333C22 9.09 22 10.143 22 12.25C22 15.761 22 17.517 21.157 18.778C20.7921 19.3242 20.3232 19.7931 19.777 20.158C18.518 21 16.762 21 13.25 21H12C7.286 21 4.929 21 3.464 19.535C2 18.072 2 15.715 2 11V7.944C2 6.128 2 5.22 2.38 4.538C2.65114 4.05208 3.05208 3.65114 3.538 3.38C4.22 3 5.128 3 6.944 3C8.108 3 8.69 3 9.2 3.191C10.363 3.627 10.843 4.684 11.368 5.733L12 7",
    stroke: "#024064",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.b50eaa9e26110fd3d9cb7277b072f8e3.svg";
export { ForwardRef as ReactComponent };